import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const DuplicateIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M3.33333 0.666626C2.6 0.666626 2 1.26663 2 1.99996V10.6666C2 11.0346 2.29867 11.3333 2.66667 11.3333C3.03467 11.3333 3.33333 11.0346 3.33333 10.6666V1.99996H10.6667C11.0347 1.99996 11.3333 1.70129 11.3333 1.33329C11.3333 0.965293 11.0347 0.666626 10.6667 0.666626H3.33333ZM6 3.33329C5.26667 3.33329 4.66667 3.93329 4.66667 4.66663V14C4.66667 14.7333 5.26667 15.3333 6 15.3333H13.3333C14.0667 15.3333 14.6667 14.7333 14.6667 14V7.21871C14.6667 6.86538 14.526 6.526 14.276 6.276L11.724 3.72392C11.474 3.47392 11.1346 3.33329 10.7812 3.33329H6ZM8 8.66663H11.3333C11.7013 8.66663 12 8.96529 12 9.33329C12 9.70129 11.7013 9.99996 11.3333 9.99996H8C7.632 9.99996 7.33333 9.70129 7.33333 9.33329C7.33333 8.96529 7.632 8.66663 8 8.66663ZM8 11.3333H11.3333C11.7013 11.3333 12 11.632 12 12C12 12.368 11.7013 12.6666 11.3333 12.6666H8C7.632 12.6666 7.33333 12.368 7.33333 12C7.33333 11.632 7.632 11.3333 8 11.3333Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

DuplicateIcon.propTypes = {
  sx: PropTypes.object,
};

export default DuplicateIcon;
